export default "__VITE_ASSET__054d3f84__"